import * as React from 'react';
// import  { Identifiable, DataClass } from 'src/shared/utility';
// import { ContainerProps } from 'src/shared/typemap';
// import { deepEqual } from 'src/shared/utility';
import * as ReactDataGrid from 'react-data-grid';
import * as ReactDataAddOn from 'react-data-grid-addons';
// import UnitName from 'src/container/Unit/UnitName';
// import SensorTypeName from 'src/container/SensorType/SensorTypeName';
// import DatetimeRenderer from 'src/components/DatetimeRenderer';
// import FixedNumber from 'src/components/FixedNumber';
// import { Button, Icon } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { SharedChartRenderProps } from 'src/container/Chart/renders/Shared';
import { TriggerableStatStore } from 'src/stores/application/triggerablestat';
import TriggerableStat from 'src/stores/application/classes/TriggerableStat';
import { ChartPoint } from 'chart.js';
import DatetimeRenderer from 'src/components/DatetimeRenderer';

type SortDirections = 'ASC' | 'DESC' | 'NONE';

interface DataGridState {
    selectedRows?: Array<any>;
    sortColumn?: string;
    sortDirection?: SortDirections;

    filters: { [key: string]: any };

    actions?: string[];

}

interface TableRendererProps extends SharedChartRenderProps {
    triggerableStats?: TriggerableStatStore;
    routing?: any;
}

@inject('triggerableStats', 'routing')
@observer
export class ChartRender extends React.Component<TableRendererProps , DataGridState> {

    get items (): any[] {
        const props = this.props;
        const datasets = props.data.datasets;

        if (datasets) {
            return datasets.map((dataset) => {
                return (dataset.data as ChartPoint[])
                    .reduce(
                        (a, b) => Object.assign(
                            a, 
                            {
                                [b.x as string]: b.y
                            }
                        ), 
                        {} as any[]);

                // let splittedLabel = ( as string).split(':');
                // let Id = splittedLabel.shift() as string;
                
                // return {
                //     Id: Id,
                //     Cells: [
                //         ...splittedLabel,
                //         ...(dataset.data as number[])
                //     ]
                // };
            });
        } else {
            return [];
        }
    }

    get columns() {
        const _triggerablestats = this.props.triggerableStats.getParsedItems as any;
        const triggerablestats = _triggerablestats.filter(
            o => o.associatedChart === this.props.CurrentChart.typedId
        ).sort( (a, b) => a.statIndex - b.statIndex) as TriggerableStat[];
        
        return [
            {
                key: 'unitName',
                name: 'Unit',
                sortable: true,
                filterable: true
            },
            {
                key: 'name',
                name: 'Sensor',
                sortable: true,
                filterable: true
            },
            {
              key: 'lastUpdate',
              name: 'Last Updated',
              filterable: true,
              editable: true,
              resizable: true,
              sortable: true,
              formatter: DatetimeRenderer
            },
            ...triggerablestats.map(o => o.toColumn())
        ] as any[];
    }

    get getOrderedItem() {       
        const { sortColumn, sortDirection } = this.state;
        const columns = this.columns;

        let endItems = [...this.items];
         
        const currentSortColumnIndex = columns.findIndex(o => o.key === sortColumn);
        if (currentSortColumnIndex >= 0) {
            const currentSortColumn = columns[currentSortColumnIndex];

            if ( currentSortColumn && currentSortColumn.sortable ) {
                if ( 
                    ['unitName', 'name', 'lastUpdate'].includes(currentSortColumn.key) 
                ) {
                    if (sortDirection === 'DESC') {
                        endItems = endItems.sort((a: any, b: any) => 
                            b[sortColumn] ?
                            a[sortColumn] ? 
                            b[sortColumn] - a[sortColumn] 
                            : -1 : -1
                        );
                    } else {
                        endItems = endItems.sort((a: any, b: any) => 
                            b[sortColumn] ?
                            a[sortColumn] ? 
                            a[sortColumn] - b[sortColumn] 
                            : -1 : -1
                        );
                    }
                } else {
                    endItems = endItems.sort(this.defaultComparision(sortDirection, sortColumn));
                }
            }
        }

        endItems = ReactDataAddOn.Data.Selectors.getRows({
            filters: this.state.filters,
            rows: endItems,
        }) as any;

        return endItems;
    }

    constructor(props: SharedChartRenderProps) {
        super(props);
        
        this.state = {
            selectedRows: [],
            filters: {}
        };
    }
    
    render() {
        const orderedItem = this.getOrderedItem;
        let rowsCount = this.getOrderedItem.length;
        let rowGetter = (index) => orderedItem[index];

        return (
            <div className="table-container">
                <div className="table-header"><h5>{this.props.CurrentChart.name}</h5></div>
                <ReactDataGrid 
                    rowsCount={rowsCount}
                    rowGetter={rowGetter}
                    cellNavigationMode="changeRow"
                    getValidFilterValues={this.getValidFilterValues.bind(this)}
                    toolbar={<ReactDataAddOn.Toolbar  
                        enableFilter={true}
                        enableAddRow={false}
                        enableDeleteRow={false}
                        filterRowsButtonText="Filter"
                    /> }
                    headerRowHeight={35}
                    columns={this.columns}
                    rowRenderer={BoundRowRenderer({})}
                    {...this.props}
                    {...this.getBindables()}
                />
            </div>
        );
    }  

    private getBindables() {
        const me = this;
        let { 
            onRowUpdated, 
            onGridRowsUpdated, 
            onGridSort,
            onAddFilter,
            onClearFilters,
            onRowSelect,
            onRowClick
        } = me;

        let bindables = { 
            onRowUpdated, 
            onGridRowsUpdated, 
            onGridSort,
            onAddFilter,
            onClearFilters,
            onRowSelect,
            onRowClick
        };
        
        Object.keys(bindables).forEach((key) => {
            bindables[key] = bindables[key].bind(me);
        });
        return bindables;
    }

    // private onRowsSelected(rows: any) {
    //     const { selectedRows } = this.state;
    //     let _selectedRows = [
    //         ...selectedRows,
    //         ... rows.map(row => row.row).filter( 
    //             row => !selectedRows.some(selectedRow => row.typedId === selectedRow.typedId)
    //         )  // removing duplicates
    //     ];

    //     this.setState({
    //         selectedRows: _selectedRows
    //     });
    // }
    
    // private onRowsDeselected = (rowDetails) => {
    //     const { selectedRows } = this.state;
    //     const rows = rowDetails.map(rowDetail => rowDetail.row);

    //     let _selectedRows = selectedRows.filter(
    //         selectedRow => !rows.some(row => row.typedId === selectedRow.typedId)
    //     );

    //     this.setState({
    //         selectedRows: _selectedRows
    //     });
    // }

    private getValidFilterValues(columnId: string) {
        let values = this.items.map(r => r[columnId]);
        return values.filter((item, i, a) => { return i === a.indexOf(item); });
    }
 
    private defaultComparision(sortDirection: 'ASC' | 'DESC' | 'NONE', sortColumn: string) {
        
        if (sortDirection === 'DESC') {
            return (
                (a: any, b: any) => 
                    a[sortColumn] < b[sortColumn] ? 1
                    : a[sortColumn] > b[sortColumn] ? -1
                    : 0
            );
        } else {
            return (
                (a: any, b: any) => 
                    a[sortColumn] < b[sortColumn] ? -1
                    : a[sortColumn] > b[sortColumn] ? 1
                    : 0
            );
        }
    }

    private onRowUpdated(e: ReactDataGrid.RowUpdateEvent) {
        // let item = this.items[e.rowIdx];
        
        // let id = typeof item === 'undefined' ? 
        //     e.cellKey === 'id' ?
        //     e.updated[e.cellKey]
        //     : uuidv1() 
        //     : item.typedId;

        // this.addUpdateRow(id, e.updated);
    }

    private onGridRowsUpdated(e: ReactDataGrid.GridRowsUpdatedEvent) {
        for (let counter = e.fromRow; counter <= e.toRow; counter++) {
            this.onRowUpdated({
                cellKey: e.cellKey,
                rowIdx: counter,
                updated: e.updated,
                key: ''
            });
        }
    }

    private onGridSort (sortColumn: string, sortDirection: 'ASC' | 'DESC' | 'NONE') {
        this.setState({ sortColumn, sortDirection});
    }

    private onAddFilter (filter: any) {
        let endObject = {
            filters: {
                ...this.state.filters,
                [filter.column.key]: filter
            }
        };

        if (
            typeof filter.filterTerm === 'undefined' 
            || filter.filterTerm === ''
        ) {
            delete endObject.filters[filter.column.key];
        }

        this.setState(endObject);
    }

    private onClearFilters () {
        this.setState({
            filters: {}
        });
    }

    private onRowSelect (rows: Array<any>) {
        // Not Implemented
    }

    private onRowClick(rowIdx: number, row: any) {
        // Not Implemented
        this.props.routing.push(`/unitsensor/${row.id}`);
    }
    
}

function BoundRowRenderer(bindProps: any) {
    return  class RowRenderer extends React.Component<any, any> {
        row: any;
        setScrollLeft = (scrollBy) => {
          // if you want freeze columns to work, you need to make sure you implement this as apass through
          this.row.setScrollLeft(scrollBy);
        }
      
        render() {
          // here we are just changing the style
          // but we could replace this with anything we liked, cards, images, etc
          // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
          return (<div><ReactDataGrid.Row ref={node => this.row = node} {...this.props}/></div>);
        }
    };
}


// WEBPACK FOOTER //
// ./src/container/Chart/renders/Table.tsx